export class JsonData {

    
		 }
	
 /* main.js:36126:13
categorydata ==>[{"id":"1","name":"Kilo Menu","description":"Kilo menu food","code":"","image":"Cat_26052017144024_09.jpg","orgId":"2"*/


// WEBPACK FOOTER //
// ./src/pages/home/dataaa.ts